import { client } from '../../graphql/client';
import { PDVS } from '../../graphql/generated-queries/pdvs-queries';

export async function getPdvs() {
  const { data } = await client.query({ query: PDVS });
  return { data: data.pDVS, total: data.pDVS.length };
}
